import FC from '@fullcalendar/react';

/**
 * A licensed version of FullCalendar that is allowed to be used in our applications
 * and does not show a warning when using premium plugins.
 * https://fullcalendar.io/docs/premium
 */
export class FullCalendar extends FC {
  static defaultProps = {
    // Version Number: 6.1.15
    // License Type: 2-Developer Renewal
    schedulerLicenseKey: '0422172873-fcs-1764711916',
  };
}
